// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1934":"b86d70f0","7671":"c6f9a5c1","8524":"d7413e9c"}[chunkId] + ".css";
};